export function getClientTimezoneOffsetInHoursNegative() {
  const date = new Date
  return date.getTimezoneOffset() / -60
}